function prefixed(prefix: string): (id: string | number) => string {
  if (!prefix.endsWith('/'))
    prefix = prefix + '/';
  return (id: string | number) => prefix + id;
}

class Routes {
  readonly Login = '/login';

  readonly Welcome = '/welcome';

  readonly Dashboard = '/dashboard';

  readonly CurrentUser = '/user/current';

  readonly UserList = '/user/list';

  readonly UserView = '/user/view/:id';
  readonly userView = prefixed('/user/view/');

  readonly UserAdd = '/user/add';

  readonly UserEdit = '/user/edit/:id';
  readonly userEdit = prefixed('/user/edit/');

  readonly X1LanguageList = '/content/language-list';

  readonly X1Language = '/content/language/:id';
  readonly x1language = prefixed('/content/language/');

  readonly X2AgeCategory = '/content/age-category/:id';
  readonly x2ageCategory = prefixed('/content/age-category/');

  readonly X3Level = '/content/level/:id';
  readonly x3level = prefixed('/content/level/');

  readonly X4Unit = '/content/unit/:id';
  readonly x4unit = prefixed('/content/unit/');

  readonly X5Lesson = '/content/lesson/:id';
  readonly x5lesson = prefixed('/content/lesson/');

  readonly X6Page = '/content/page/:id';
  readonly x6page = prefixed('/content/page/');

  readonly X7PushableBlock = '/content/pushable-block/:id';
  readonly x7pushableBlock = prefixed('/content/pushable-block/');

  readonly StudentSchedule = '/student/schedule';
  readonly StudentClassroom = '/student/classroom/:id';
  readonly studentClassroom = prefixed('/student/classroom/');
  readonly StudentHomework = '/student/homework/:id';
  readonly StudentHomeworkLink = prefixed('/student/homework/');
  readonly StudentHomeworkList = '/student/homework';
  // Essay
  readonly EssayStudent = '/student/essay/:id';
  readonly EssayStudentLink = prefixed('/student/essay/');
  readonly EssayTeacher = '/teacher/essay/:id';
  readonly EssayTeacherLink = prefixed('/teacher/essay/');
  readonly EssayTeacherList = '/teacher/essay/list';
  readonly EssayStudentList = '/student/essay/list';
  
  // Exam
  readonly ExamTeacherList = '/teacher/exam/list';
  readonly ExamStudentList = '/student/exam/list';
  readonly ExamStudent = '/student/exam/:id';
  readonly ExamStudentLink = prefixed('/student/exam/');
  readonly ExamTeacher = '/teacher/exam/:id';
  readonly ExamTeachertLink = prefixed('/teacher/exam/');

  readonly TeacherSchedule = '/teacher/schedule';
  readonly TeacherClassroom = '/teacher/classroom/:id';
  readonly teacherClassroom = prefixed('/teacher/classroom/');
  readonly TeacherWorkDays = '/teacher/workdays';
  readonly TeacherLessons = '/teacher/lessons';
  readonly TeacherStudents = '/teacher/students';

  readonly AdminClassrooms = '/admin/classrooms';
  readonly ClassroomDetails = '/admin/classroom/:id';
  readonly classroomDetails = prefixed('/admin/classroom/');

  readonly TimeZoneList = '/timezones';
  readonly Test = '/test';
  readonly RegistrationList = '/registration/list';

  readonly StudentProfile = '/student/profile/:id';
  readonly studentProfile = prefixed('/student/profile/');
}

export const routes = new Routes();
